import { useEffect, useState } from "react";

// Given a UTC ISO start_time string, return live HH:MM:SS since then.
export function useLiveTimer(startIso) {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        if (!startIso) return;
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, [startIso]);
    if (!startIso) return "00:00:00";
    const start = new Date(startIso).getTime();
    const s = Math.max(0, Math.floor((now - start) / 1000));
    const hh = String(Math.floor(s / 3600)).padStart(2, "0");
    const mm = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
    const ss = String(s % 60).padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
}
